import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../theme';
import { FA_SELECTOR } from '../styles/variables';

const HEADING_3_SIZE = 24;
const HEADING_4_SIZE = 18;

export const useDetailPageHeadersStyles = createStyles(({ token }) => ({
  detailPageHeader: {
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    backgroundColor: ThemeColors.COLOR_WHITE2,
    boxShadow: `-1px -1px 1px ${ThemeColors.COLOR_WHITE}, 6px 6px 15px ${hexToRgbaWithAlpha(
      ThemeColors.COLOR_GREY9,
      0.85
    )}`,
    borderRadius: token.borderRadius,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      padding: `0 ${ThemeSpaces.SPACE_SM}px`,
    },

    '> .ant-row': {
      height: '100%',
    },

    'h2.ant-typography': {
      marginBottom: 0,
      letterSpacing: '-0.35px',
      fontFamily: ThemeFont.FONT_CONDENSED,
      color: ThemeColors.COLOR_GREY1_5,

      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          fontSize: HEADING_3_SIZE,
        },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
        {
          fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        fontSize: HEADING_4_SIZE,
      },
    },
  },
  detailPageHeaderSize40: {
    height: 40,
  },
  detailPageHeaderWithBackLink: {
    paddingRight: ThemeSpaces.SPACE_NORM_20,

    '.InlineLink': {
      fontSize: token.fontSizeSM,
      fontFamily: ThemeFont.FONT_FAMILY4,
      fontWeight: 600,
      color: ThemeColors.COLOR_GREY3,
      textTransform: 'uppercase',

      [`@media (max-width: ${token.screenXSMax}px)`]: {
        fontSize: ThemeFont.FONT_SIZE_XS,
      },

      [FA_SELECTOR]: {
        '&:first-child': {
          fontSize: 18,
          color: token.colorPrimary,
          marginRight: ThemeSpaces.SPACE_MD,
        },
      },
    },
  },
}));
